export default __webpack_public_path__ + "static/media/card-w-app@2x.672e8e95.png";